export default {
      id: "ten-percent-usage",
      viewBox: "0 0 57 33",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#ten-percent",
      toString: function () {
        return this.url;
      }
    }